export default __webpack_public_path__ + "static/media/download-orange.3a46778f.svg";